import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdsCampaign } from '../classes/ads-campaign';
import { Observable } from 'rxjs';
import { Organization } from '../classes/organization';
import { Shift } from '../classes/shift';

@Injectable({
  providedIn: 'root'
})
export class AdsCampaignService {

  constructor(private httpClient: HttpClient) { }

  public copy(adsCampaignId: number): Observable<AdsCampaign> {
    return this.httpClient.get<AdsCampaign>(`/api/media/campaigns/${adsCampaignId}/copy`);
  }

  public search(params: {}): Observable<AdsCampaign[]> {
    return this.httpClient.get<AdsCampaign[]>('/api/media/campaigns', { params: new HttpParams({ fromObject: params }) });
  }

  public get(adsCampaignId: number): Observable<AdsCampaign> {
    return this.httpClient.get<AdsCampaign>(`/api/media/campaigns/${adsCampaignId}`);
  }

  public examples(adsCampaignId: number, params: {}): Observable<Shift[]> {
    return this.httpClient.get<Shift[]>(`/api/media/campaigns/${adsCampaignId}/examples`, { params: new HttpParams({ fromObject: params }) });
  }

  public save(adsCampaignId: number, adsCampaign: AdsCampaign): Observable<AdsCampaign> {
    return this.httpClient.post<AdsCampaign>(`/api/media/campaigns/${adsCampaignId ? adsCampaignId : ''}`, adsCampaign);
  }

  public delete(adsCampaignId: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/media/campaigns/${adsCampaignId}`);
  }

  public organizations(): Observable<Organization[]> {
    return this.httpClient.get<Organization[]>('/api/media/organizations');
  }

  public recent(): Observable<AdsCampaign[]> {
    return this.httpClient.get<AdsCampaign[]>('/api/media/campaigns/recent');
  }
}
